export const OPEN_PUBLIC_CHAT_EVENT = "repackify:open-public-chat";

export function openPublicChat(message: string): void {
  window.dispatchEvent(
    new CustomEvent(OPEN_PUBLIC_CHAT_EVENT, { detail: message }),
  );
}

export const OPEN_SUPPORT_CHAT_EVENT = "repackify:open-support-chat";

export function openSupportChat(): void {
  window.dispatchEvent(new Event(OPEN_SUPPORT_CHAT_EVENT));
}
